import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_audit_trails: { message: "idle" },
};

export const retrieve_tenant_audit_trails_Slice = createSlice({
 name: "retrieve_tenant_audit_trails",
 initialState,
 reducers: {
  success_retrieve_tenant_audit_trails: (state, action) => {
   state.retrieve_tenant_audit_trails = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_audit_trails: (state, action) => {
   state.retrieve_tenant_audit_trails = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_audit_trails: (state) => {
   state.retrieve_tenant_audit_trails = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_audit_trails: (state) => {
   state.retrieve_tenant_audit_trails = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_audit_trails, fail_retrieve_tenant_audit_trails, reset_retrieve_tenant_audit_trails, loading_retrieve_tenant_audit_trails } = retrieve_tenant_audit_trails_Slice.actions;

export default retrieve_tenant_audit_trails_Slice.reducer;